import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';
import { ConsumerCheckoutPage } from '../../pages/consumer-checkout/consumer-checkout';

import { PurchaseHandlerProvider } from '../../providers/purchase-handler';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

@Component({
  selector: 'page-consumer-offer-manager',
  templateUrl: 'consumer-offer-manager.html',
})
export class ConsumerOfferManagerPage {
	filePath: any;	
	loader: any;
	qrCodeUrl: any;	
	caller: any;
	offer: any = {};
	offerMedia: any;
	refreshDone: boolean = false;
	leftView: boolean = false;
	isLoading: boolean = false;
	hasMedia: boolean = false;
	lastRedeemDate: any;
	needsRefresh: boolean = false;

	apiCallQty: any = 0;

	isRefreshing: boolean = false;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public alertCtrl: AlertController,
		public utils: Utils,
		public offerProvider: ConsumerOfferManagerHandler,
		public purchaseHandlerProvider: PurchaseHandlerProvider,
		public loadingCtrl: LoadingController,
		public globals: Globals,
	) {
		var offer = navParams.get('offer');

		this.offer.Id = offer.Id;
		this.isLoading = true;

		this.filePath = this.globals.fileUrl;		
	}

	ionViewWillEnter() {
		this.isLoading = true;
		
	    this.reloadOffer(null, this.offer.Id);
	}

	loadMedia(offerId){
		this.isLoading = true;

		this.offerProvider.getOfferMedia({
			id: this.offer.Id,
			cb: (result)=>{ 
				if(result){
			    	this.offerMedia = result;

			    	this.hasMedia = this.offerMedia.length > 0;		    	
			  	}

			  	this.isLoading = false;
			}
		})
	}

	reloadOffer(cb, id){
		this.offerProvider.getOfferDetail({id: id, cb: 
			(offer)=>{
				this.offer = offer;

				this.loadMedia(this.offer.Id);

				if(typeof cb == "function") cb();
			}
		});
	}

	doRefresh(refresher){
		this.isRefreshing = true;

		this.reloadOffer(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		}, this.offer.Id)		
	}

	redeemOffer(offer){
		this.offerProvider.selectedOffer = offer;

		if(offer.RedeemDate!=this.lastRedeemDate){
			let alert = this.alertCtrl.create({
				title: 'Offer redeemed',
				subTitle: 'Enjoy!',
				buttons: ['Ok']
			});

			alert.present();				

			// this.offerProvider.updateOffer(offer);
			
			this.needsRefresh = false;
		}else{
			this.needsRefresh = true;
		}
	}

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}	

	gotoCheckout(offer){
		console.log("Offer");
		console.log(offer);

		this.navCtrl.push(ConsumerCheckoutPage, {
			requiresReload: true,
			offer: offer
		});				
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-manager/consumer-offer-manager.ts